/* eslint-disable react/react-in-jsx-scope */
import { iMessage, iStore } from 'domain/interfaces/models';
import { MessageOptions } from 'domain/interfaces/redux/message';
import { makeReduxActiveMessage } from 'main/factories/usecases/message/Update';
import { IconCloseButtonModal } from 'presentation/base/icons';
import { useSelector } from 'react-redux';
import { Drawer } from '../drawer';
import { translator } from '../i18n';
import { mapLog, mapLogUser } from './functions';
import {
  CloseButton,
  CloseButtonContainer,
  ContentSection,
  ContentSectionItem,
  ContentSectionItemLabel,
  ContentSectionItemValue,
  Divider,
  DrawerTitle,
  Padding,
  Section,
  TableOrganizations,
  TableOrganizationsBody,
  TableOrganizationsCell,
  TableOrganizationsRow,
  TitleSection,
} from './styles';

type AuditRecordDrawerProps = {
  message: iMessage;
};

const AuditRecordDrawer: React.FC<AuditRecordDrawerProps> = ({ message }) => {
  const handleClose = () => {
    makeReduxActiveMessage().active({
      active: MessageOptions.none,
    });
  };

  const { active, userId } = message;
  const isActive = active === MessageOptions.viewAudit;

  const { audit } = useSelector((store: iStore) => store);
  const logSelected = audit.logs?.records.find(log => log.id === userId);

  const logMapped = mapLog(logSelected as any);
  const logUserMapped = mapLogUser(logSelected as any);

  return (
    <Drawer
      isOpen={isActive}
      style={{ padding: 0 }}
      anchor="right"
      handleClose={handleClose}
    >
      <Padding>
        <CloseButtonContainer>
          <CloseButton>
            <IconCloseButtonModal onClick={handleClose} />
          </CloseButton>
        </CloseButtonContainer>
        <DrawerTitle>{translator('Detalhes da operação')}</DrawerTitle>
      </Padding>
      <Divider />
      <Padding paddingTopBottom="0">
        <Section>
          <TitleSection>{translator('Evento')}</TitleSection>
          <ContentSection>
            {logMapped.map(item => (
              <ContentSectionItem key={item.label}>
                <ContentSectionItemLabel>
                  {`${translator(item.label)}:`}
                </ContentSectionItemLabel>
                <ContentSectionItemValue>{item.value}</ContentSectionItemValue>
              </ContentSectionItem>
            ))}
          </ContentSection>
        </Section>
      </Padding>
      <Divider />
      <Padding paddingTopBottom="0">
        <Section>
          <TitleSection>{translator('Usuário')}</TitleSection>
          <ContentSection>
            {logUserMapped.map(item => {
              return item.isTable ? (
                <ContentSectionItem
                  key={item.label}
                  flexDirection="column"
                >
                  <ContentSectionItemLabel>
                    {`${translator(item.label)}:`}
                  </ContentSectionItemLabel>
                  <TableOrganizations>
                    <TableOrganizationsBody style={{ maxHeight: '10rem' }}>
                      {item.value.map(org => (
                        <TableOrganizationsRow key={org.name}>
                          <TableOrganizationsCell>
                            {org.name}
                          </TableOrganizationsCell>
                          <TableOrganizationsCell
                            style={{
                              color: '#818385',
                              fontSize: '0.875rem',
                              fontWeight: 400,
                            }}
                          >
                            {org.role}
                          </TableOrganizationsCell>
                        </TableOrganizationsRow>
                      ))}
                    </TableOrganizationsBody>
                  </TableOrganizations>
                </ContentSectionItem>
              ) : (
                <ContentSectionItem key={item.label}>
                  <ContentSectionItemLabel>
                    {`${translator(item.label)}:`}
                  </ContentSectionItemLabel>
                  <ContentSectionItemValue>
                    {item.value}
                  </ContentSectionItemValue>
                </ContentSectionItem>
              );
            })}
          </ContentSection>
        </Section>
      </Padding>
    </Drawer>
  );
};

export default AuditRecordDrawer;
